import React from 'react';
import { useLocomotiveScroll } from 'react-locomotive-scroll';

const SmoothScrollLink = ({ to, children }) => {
  const { scroll } = useLocomotiveScroll();

  const handleClick = (e) => {
    e.preventDefault();
    const targetElement = document.querySelector(to);
    if (scroll && targetElement) {
      scroll.scrollTo(targetElement, {
        // Center the target in the viewport, like scrollIntoView({ block: 'center' })
        offset: -Math.max(0, (window.innerHeight - targetElement.offsetHeight) / 2),
      });
    }
  };

  return (
    <a href={to} onClick={handleClick}>
      {children}
    </a>
  );
};

export default SmoothScrollLink;
